// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 425) return "static/chunks/425-1f3992fc481a8c3a.js";
	if (chunkId === 957) return "static/chunks/957-df2e6f96efe363ad.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"a4288b99734887fc","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"da2fd2ed04595c0f","367":"3b07106474e6c73d","639":"f9988732d5223815","748":"97756e1dded69b49"}[chunkId] + ".js";
};